/* ARRAY - collection pager. 2 Oct 2026.
   sections/beyondads-collection.liquid prints up to 250 products in one block, in-stock first and
   sold-out last. This splits that block into numbered pages of data-per (24) using the existing
   .bc-pages / .bc-page styles, so sold-out products land on the last pages. The page number lives
   in ?pg=N (back/forward and shared links keep it); changing page scrolls back to the grid. */
(function () {
  'use strict';
  if (window.__bcPages) return;
  window.__bcPages = true;

  function cardsOf(g) {
    return Array.prototype.filter.call(g.children, function (el) { return el.classList.contains('bc-card'); });
  }
  function readPg() {
    var m = location.search.match(/[?&]pg=(\d+)/);
    return m ? Math.max(1, +m[1]) : 1;
  }
  function urlFor(n) {
    var url = new URL(location.href);
    if (n > 1) url.searchParams.set('pg', n); else url.searchParams.delete('pg');
    return url.toString();
  }
  function writePg(n, push) {
    history[push ? 'pushState' : 'replaceState']({ bcpg: n }, '', urlFor(n));
  }

  function build(g) {
    if (g.__pg) return;
    g.__pg = true;
    var per = Math.max(1, parseInt(g.getAttribute('data-per'), 10) || 24);
    var nav = g.parentNode.querySelector('[data-bc-pager]');

    function total() { return Math.max(1, Math.ceil(cardsOf(g).length / per)); }

    function link(label, n, cls, aria) {
      var a = document.createElement('a');
      a.className = 'bc-page' + (cls ? ' ' + cls : '');
      a.href = urlFor(n);
      a.textContent = label;
      if (aria) a.setAttribute('aria-label', aria);
      a.setAttribute('data-pg', n);
      return a;
    }
    function draw(cur) {
      if (!nav) return;
      var T = total();
      nav.innerHTML = '';
      nav.hidden = T < 2;
      if (T < 2) return;
      if (cur > 1) nav.appendChild(link('‹', cur - 1, 'bc-page--arrow', 'Previous page'));
      var shown = {};
      if (T <= 7) { for (var k = 1; k <= T; k++) shown[k] = true; }
      else [1, cur - 1, cur, cur + 1, T].forEach(function (n) { if (n >= 1 && n <= T) shown[n] = true; });
      var last = 0;
      for (var n = 1; n <= T; n++) {
        if (!shown[n]) continue;
        if (last && n - last > 1) {
          var gap = document.createElement('span');
          gap.className = 'bc-page';
          gap.textContent = '…';
          gap.setAttribute('aria-hidden', 'true');
          nav.appendChild(gap);
        }
        if (n === cur) {
          var on = document.createElement('span');
          on.className = 'bc-page is-on';
          on.setAttribute('aria-current', 'page');
          on.textContent = n;
          nav.appendChild(on);
        } else {
          nav.appendChild(link(String(n), n, '', 'Page ' + n));
        }
        last = n;
      }
      if (cur < T) nav.appendChild(link('›', cur + 1, 'bc-page--arrow', 'Next page'));
    }
    function show(n, scroll) {
      var T = total();
      n = Math.min(Math.max(1, n), T);
      var lo = (n - 1) * per, hi = lo + per;
      cardsOf(g).forEach(function (c, i) { c.classList.toggle('is-off', i < lo || i >= hi); });
      g.classList.add('is-paged');
      draw(n);
      g.__cur = n;
      if (scroll) {
        var top = g.getBoundingClientRect().top + window.pageYOffset - 140;
        window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
      }
    }

    if (nav) {
      nav.addEventListener('click', function (e) {
        var a = e.target.closest && e.target.closest('[data-pg]');
        if (!a) return;
        e.preventDefault();
        var n = +a.getAttribute('data-pg');
        writePg(n, true);
        show(n, true);
      });
    }
    window.addEventListener('popstate', function () { show(readPg(), true); });
    show(readPg(), false);
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-bc-paged]'), build);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function () {
    Array.prototype.forEach.call(document.querySelectorAll('[data-bc-paged]'), function (g) { g.__pg = false; build(g); });
  });
})();
